// Promoted to `@orn/shared-web` so `@orn/mops-web` can consume it without
// copy-paste drift. Re-exported here to preserve existing call sites.
export { default as filterNullsAndUndefined } from '@orn/shared-web/utils/filterNullsAndUndefined';

// Sensitive keys that should be redacted from logs
const SENSITIVE_KEYS = [
  'publicToken',
  'linkToken',
  'accessToken',
  'token',
  'password',
  'secret',
  'apiKey',
  'api_key',
  'authorization',
  'auth',
] as const;

/**
 * Recursively sanitizes an object by redacting sensitive keys
 * Prevents sensitive data (like tokens, passwords) from being logged to error tracking services
 */
export function sanitizeVariables(obj: unknown, depth = 0): unknown {
  // Prevent infinite recursion
  if (depth > 10) {
    return '[Max depth reached]';
  }

  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => sanitizeVariables(item, depth + 1));
  }

  if (typeof obj === 'object') {
    const sanitized: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      const lowerKey = key.toLowerCase();
      const isSensitive = SENSITIVE_KEYS.some((sensitiveKey) => lowerKey.includes(sensitiveKey.toLowerCase()));

      if (isSensitive) {
        sanitized[key] = '[REDACTED]';
      } else {
        sanitized[key] = sanitizeVariables(value, depth + 1);
      }
    }
    return sanitized;
  }

  return obj;
}
